module.exports = __webpack_public_path__ + "media/images/emblems/PregnyChambesy-coat_of_arms-453d34df4636f38dc490e563f3a514b8.svg";